import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Avatar, Tooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import AccountCircle from "@material-ui/icons/AccountCircle";

import { getAvatar, getInitials } from "utils/app.util";
import { getCurrentUserFromState } from "app/app.selectors";

class CurrentUserAvatar extends PureComponent {
  render() {
    const { classes, currentUser, dispatch, ...rest } = this.props;

    const avatar = currentUser.get("avatar");
    const initials = getInitials(currentUser.get("displayName"));

    return (
      <Tooltip title={currentUser.get("fullName") || ""}>
        <Avatar
          src={getAvatar(currentUser.get("avatar"))}
          classes={{
            root: classes.root,
          }}
          {...rest}
        >
          {avatar || initials || <AccountCircle />}
        </Avatar>
      </Tooltip>
    );
  }
}

const styles = theme => ({
  root: {
    cursor: "pointer",
    "&:hover": {
      opacity: 0.7,
    },
  },
});

export default compose(
  connect(state => ({
    currentUser: getCurrentUserFromState(state),
  })),
  withStyles(styles),
)(CurrentUserAvatar);
